<style lang="scss" scoped>
    #documentRejectionModal .modal-dialog {
        padding: 150px 0;
        margin: auto;

        @media (max-width: 1024px) {
            width: 90vw;
        }

        @media (max-width: 767px) {
            width: 100vw;
        }
    }

    .modal-button {
        float: left;
        padding-left: 40px;
        padding-right: 40px;
    }

    .form-check-label {
        font-size: 14px;
    }

    .bold-style {
        font-weight: bold;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
    }

    .modal-title {
        border: 0;
    }

    .close {
        background: transparent;
        border: 0;
        color: #00A8E1;

        span {
            font-size: 20px;
        }
    }

    .modal-body {
        .container {
            width: 100%;
        }
    }

    .modal-footer {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
</style>

<template>
    <div class="modal fade" id="documentRejectionModal" tabindex="-1" role="dialog"
         aria-labelledby="documentRejectionModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="documentApprovalModalLabel">Document Rejection Confirmation</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 ">
                                <h4>Are you sure?</h4>
                                <h6>Clicking Yes will permanently remove the document from the portal.</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 ">
                                <h6><span class="label label-default">Reasons for rejection</span></h6>
                                <textarea v-model="comment" class="form-control" id="inputComment" placeholder="Reason for rejection"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button"
                            data-toggle="modal"
                            data-target="#documentRejectionModal"
                            @click="handleSubmit"
                            class="btn btn-primary modal-button">Yes, reject</button>
                    <button type="button"
                            class="float-right btn btn-default modal-button"
                            data-dismiss="modal"
                            aria-label="No, cancel">
                        No, cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { REJECT_DOCUMENT, FETCH_TASKS } from "../../store/actions.type";
    import { COMMENT_CHANGED } from "../../store/mutations.type";

    export default {
        name: "DocumentRejectionModal",
        computed: {
            comment: {
                get () {
                    return this.$store.state.myAdmin.formData.comment;
                },
                set (value) {
                    this.commit(COMMENT_CHANGED, value);
                }
            }
        },
        methods: {
            commit(mutation, payload) {
                return this.$store.commit('myAdmin/' + mutation, payload);
            },
            dispatch(action, payload) {
                return this.$store.dispatch('myAdmin/' + action, payload);
            },
            handleSubmit() {
                this.dispatch(REJECT_DOCUMENT).then(() => this.dispatch(FETCH_TASKS));
            },
        }
    }
</script>
